import React from "react";
import PolicyLayout from "../../components/PolicyLayout";
import { Highlight } from "../HomePage";

const ShippingDelivery = () => {
  return (
    <PolicyLayout title={<>Shipping &amp; Delivery <Highlight tone="dark">Policy</Highlight></>}>
      <i style={{ fontSize: 14 }}>Last updated on Jan 29th 2025</i>
      <ul>
        <li>
          1. Service orders are fulfilled by our empaneled health
          providers through their qualified technicians or
          phlebotomist or staff.
        </li>
        <li>
          2. Product orders are shipped through registered domestic
          courier companies and /or speed post only.
        </li>
        <li>
          3. Orders are shipped within 0-7 days or as per the delivery
          date agreed at the time of order confirmation and delivering
          of the shipment subject to Courier Company / post office
          norms.
        </li>
        <li>
          4. ANJ BUSINESS SOLUTIONS PRIVATE LIMITED is not liable for
          any delay in delivery by the courier company / postal
          authorities and only guarantees to hand over the consignment
          to the courier company or postal authorities within 0-7 days
          from the date of the order and payment or as per the delivery
          date agreed at the time of order confirmation.
        </li>
        <li>
          5. Delivery of all orders will be to the address provided by
          the buyer.
        </li>
        <li>
          6. Delivery of our services will be confirmed on your mail
          ID as specified during registration. For any issues in
          utilizing our services you may contact our helpdesk on{" "}
          <a href="tel:18003092740" style={{ display: "inline" }}>
             1800 309 2740
          </a>{" "}
          or{" "}
          <a
            href="mailto:hello@swasthopd.com"
            style={{ display: "inline" }}
          >
            hello@swasthopd.com
          </a>
          .
        </li>
      </ul>
    </PolicyLayout>
  );
};

export default ShippingDelivery;
